import animationBlue from 'img/nestleLanding/animations/breed/blue.riv';
import animationBlueMobile from 'img/nestleLanding/animations/breed/blue_mobile.riv';
import bgBlue from 'img/nestleLanding/animations/breed/blue_static.png';
import bgBlueMobile from 'img/nestleLanding/animations/breed/blue_static_mobile.png';
import animationGreen from 'img/nestleLanding/animations/breed/green.riv';
import animationGreenMobile from 'img/nestleLanding/animations/breed/green_mobile.riv';
import bgGreen from 'img/nestleLanding/animations/breed/green_static.png';
import bgGreenMobile from 'img/nestleLanding/animations/breed/green_static_mobile.png';
import animationPink from 'img/nestleLanding/animations/breed/pink.riv';
import animationPinkMobile from 'img/nestleLanding/animations/breed/pink_mobile.riv';
import bgPink from 'img/nestleLanding/animations/breed/pink_static.png';
import bgPinkMobile from 'img/nestleLanding/animations/breed/pink_static_mobile.png';
import animationRed from 'img/nestleLanding/animations/breed/red.riv';
import animationRedMobile from 'img/nestleLanding/animations/breed/red_mobile.riv';
import bgRed from 'img/nestleLanding/animations/breed/red_static.png';
import bgRedMobile from 'img/nestleLanding/animations/breed/red_static_mobile.png';
import { CardColor } from 'reactApp/sections/Nestle/PetsCard/PetsCard.types';

export const animations = {
    [CardColor.blue]: animationBlue,
    [CardColor.green]: animationGreen,
    [CardColor.red]: animationRed,
    [CardColor.pink]: animationPink,
};

export const animationsMobile = {
    [CardColor.blue]: animationBlueMobile,
    [CardColor.green]: animationGreenMobile,
    [CardColor.red]: animationRedMobile,
    [CardColor.pink]: animationPinkMobile,
};

export const backgroundImages = {
    [CardColor.blue]: bgBlue,
    [CardColor.green]: bgGreen,
    [CardColor.red]: bgRed,
    [CardColor.pink]: bgPink,
};

export const backgroundImagesMobile = {
    [CardColor.blue]: bgBlueMobile,
    [CardColor.green]: bgGreenMobile,
    [CardColor.red]: bgRedMobile,
    [CardColor.pink]: bgPinkMobile,
};
